module.exports = __webpack_public_path__ + "static/wx.481dc135.png";